import { services } from '@octadesk-tech/services'
import store from '@/store'
import { getParameterHeaders } from './headers'

const getClient = () => {
  const headers = getParameterHeaders()
  return services.createClient('widgetBff', { headers })
}

export const getLastUpdate = roomKey =>
  getClient()
    .then(client => client.head(`rooms/${roomKey}/last-modified`))
    .then(response => response.headers['last-modified'])

export const getRoom = roomKey =>
  getClient()
    .then(client => client.get(`rooms/${roomKey}`))
    .then(response => response.data)

export const executeRules = (roomKey, type) =>
  getClient()
    .then(client =>
      client.post(`rooms/${roomKey}/rules/${type}/execute`, null, {
        params: {
          sd: store.getters.company
        }
      })
    )
    .then(res => res.data)

export const setLastDomainFrom = (roomKey, url) => {
  if (!roomKey) {
    return Promise.resolve()
  }

  return getClient().then(client =>
    client.put(`rooms/${roomKey}/domain`, { url })
  )
}

export const includeChatArticle = (roomKey, article) =>
  getClient().then(client =>
    client.put(`rooms/${roomKey}/articles`, article, {
      headers: getParameterHeaders()
    })
  )

export const surveyResponse = (roomKey, survey) =>
  getClient()
    .then(client => client.post(`rooms/${roomKey}/survey`, survey))
    .then(res => res.data)

export const surveyOpened = roomKey =>
  getClient().then(client => client.put(`rooms/${roomKey}/survey/sended`, null))

export const surveyComment = (roomKey, comment) =>
  getClient()
    .then(client => client.put(`rooms/${roomKey}/survey/comment`, comment))
    .then(res => res.data)
